export default __webpack_public_path__ + "static/media/2019-3.6d7e3d70.jpeg";